import { useCallback, useMemo, useState } from 'react';
import { ResponsiveTabItem } from './ResponsiveTabList';

export interface ResponsiveTab<T extends string> extends ResponsiveTabItem<T> {
    content: React.ReactNode;
}

const useResponsiveTabList = <T extends string>(
    tabs: readonly ResponsiveTab<T>[],
    initialTab: T
) => {
    const [selectedTabId, setSelectedTabId] = useState<T>(initialTab);

    const setSelectedTabIdCallback = useCallback((val: string) => {
        if (val) {
            setSelectedTabId(val as T);
        }
    }, []);

    const selectedTab = useMemo(
        () => tabs.find((x) => x.id === selectedTabId)!,
        [tabs, selectedTabId]
    );

    return {
        selectedTab,
        setSelectedTabId: setSelectedTabIdCallback,
    };
};

export default useResponsiveTabList;
